<template>
  <div>
    <v-card class="my-1">
      <v-card-title>Previous Remuneration YTD (TP3) Reports</v-card-title>
      <v-row class="px-4">
        <v-col>
          <v-autocomplete
            v-model="selectedCompanies"
            v-validate="'required'"
            :loading="dropdownLoading"
            label="Companies"
            item-text="name"
            item-value="id"
            :items="companies"
            clearable
            multiple
            hide-selected 
            chips
            small-chips
            deletable-chips
            :error-messages="errors.collect('selectedCompanies')"
            data-vv-name="selectedCompanies"  
            data-vv-as="companies"
          />
        </v-col>
  
        <v-col
          cols="2"
          class="ma-auto"
        >
          <v-row
            v-if="loading" 
            class="text-center"
          >
            <v-col cols="12">
              <div>
                <span class="font-weight-bold">Downloading</span>
              </div>
              <v-progress-circular
                :rotate="360"
                :size="50"
                :width="5"
                :value="progressbar"
                color="teal"
              >
                {{ progressbar }}
              </v-progress-circular>
            </v-col>
          </v-row>
      
          <v-row class="text-center">
            <v-col cols="12">
              <v-btn
                class="mx-3"
                color="primary"
                :loading="loading"
                @click="generateEmployeePreviousRemunerationReport"
              >
                generate
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        loading: false,
        companies: [],
        selectedCompanies: [],
        dropdownLoading: false,
        progressbar: 0,
      }
    },
    created () {
      this.dropdownLoading = true

      this.$api.hrisCompanies().list()
        .then(res => {
          this.companies = _.orderBy(res.data, ['name'], ['asc'])

          this.companies.unshift({ id: 'ALL', name: 'All Companies' })

          this.dropdownLoading = false
        })
    },
    methods: {
      generateEmployeePreviousRemunerationReport () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.loading = true

            this.$api.payrollReports().employeePreviousRemuneration(this.prepareFormData(), {
              onDownloadProgress: (progressEvent) => {
                this.progressbar = (Math.floor((progressEvent.loaded * 100) / progressEvent.total))
              },
            })
              .then(res => {
                let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.setAttribute('download', 'Employee Previous Remuneration Reports' + '.xlsx')
                link.click()
                this.loading = false
                this.progressbar = 0

                this.$snack({ message: 'Report downloaded successfully' })
              }).catch(() => {
                this.loading = false
                this.$snack({ color: 'error', message: 'Error! Please contact support' })
              })
          })
      },

      prepareFormData () {
        return {
          companies: this.selectedCompanies.includes('ALL') ? (
            this.companies.filter(company => {
              return company.id !== 'ALL'
            }).map(company => {
              return company.id
            })
          ) : this.selectedCompanies,
        }
      },
    },
  }
</script>
